<template>
  <FormGroup>
    <div class="btn-group btn-group-custom" role="group">
      <button type="button"
        @click.stop="onDisabledOverrideProperties()"
        :class="{'is-selected' : !scheduleItem.overrideProgramProperties }"
        class="btn btn-outline-dark">เลือกใช้ค่าดั้งเดิม</button>
      <button type="button"
        @click.stop="onEnabledOverrideProperties()"
        :class="{'is-selected' : scheduleItem.overrideProgramProperties }"
        class="btn btn-outline-dark">ตั้งค่าใหม่</button>
    </div>
  </FormGroup>
</template>

<script>
import _ from 'lodash';
import FormGroup from '@/components/FormGroup.vue';

export default {
  props: {
    scheduleItem: {
      type: Object,
      default: () => {},
    },
    updateScheduleItemStateError: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FormGroup,
  },
  methods: {
    onDisabledOverrideProperties() {
      const program = _.get(this.scheduleItem, 'program', null);
      if (program) {
        // reset value to program
        this.onSelected({
          overrideProgramProperties: false,
          program: _.cloneDeep(program),
          programTitle: _.cloneDeep(program.title),
          coverImage: _.cloneDeep(program.coverImage),
          coverImageCustom: _.cloneDeep(program.coverImageCustom),
          broadcastingChannels: _.cloneDeep(program.broadcastingChannels),
          features: _.cloneDeep(program.features),
          contentCategory: _.cloneDeep(program.contentCategory),
        });
      } else {
        this.onSelected({
          overrideProgramProperties: false,
        });
      }
    },
    onEnabledOverrideProperties() {
      const newPayload = { overrideProgramProperties: true };
      this.onSelected(newPayload);
    },
    onSelected(newPayload) {
      this.$emit('update:scheduleItem', {
        ...this.scheduleItem,
        ...newPayload,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.btn-group {
  margin-top: $spacer * 1.5;

  .btn {
    border-right-width: 0;

    &:last-child {
      border-right-width: 1px;
    }

    &.is-selected, &:hover {
      background-color: $gray-400;
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    }
  }
}
</style>
